// extracted by mini-css-extract-plugin
module.exports = {"root":"EditWhatsAppMessageAction_root__3Ro5V"};